import { MessagesSquare } from "lucide-react";
import { Reveal } from "./Reveal";
import { PACKAGES } from "@/lib/site";

export default function NotSure({ onRequest }) {
  return (
    <section data-testid="not-sure-section" className="bg-[#FAF7F2] pb-16 lg:pb-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="bg-[#EAF0EC] border border-[#5B7566]/20 rounded-3xl p-8 lg:p-12 flex flex-col lg:flex-row lg:items-center gap-8">
            <div className="w-14 h-14 rounded-full bg-[#1B3B2B] flex items-center justify-center shrink-0">
              <MessagesSquare className="w-6 h-6 text-[#C5A059]" />
            </div>
            <div className="flex-1">
              <h3 className="font-serif text-2xl lg:text-3xl text-[#1B3B2B] tracking-tight">
                Not sure which pathway is right for your child?
              </h3>
              <p className="mt-3 text-sm sm:text-base text-[#5C6E62] leading-relaxed">
                Tell us about your child's needs and our team will help you understand which consultation pathway may be
                appropriate.
              </p>
            </div>
            <button
              data-testid="not-sure-cta"
              onClick={() => onRequest(PACKAGES.unsure)}
              className="shrink-0 bg-[#1B3B2B] text-[#FAF7F2] font-semibold tracking-wide text-[13px] px-7 py-4 rounded-full hover:bg-[#132C20] transition-all duration-300 hover:-translate-y-0.5"
            >
              TALK TO OUR USA CONSULTATION TEAM
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
